module.exports = __webpack_public_path__ + "static/media/project-seedscreen.523c0546.jpg";